import { render, staticRenderFns } from "./BasicStatisticsRow.vue?vue&type=template&id=684b14c2&"
import script from "./BasicStatisticsRow.vue?vue&type=script&lang=js&"
export * from "./BasicStatisticsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports